import React, { memo } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useCookiesContext } from '../../../../contexts/CookiesContext';
import { requiredLabels } from '@revbox/localization';

const MAX_LENGTH = 255

const errorMessagesLabels = {
    EN: {
        valueIsTooLong: `Value is too long. Maximum ${MAX_LENGTH} characters allowed.`
    },
    FR: {
        valueIsTooLong: `La valeur est trop longue. Maximum ${MAX_LENGTH} caractères autorisés.`
    }
}


function TextInput({ label, required, placeholder, value, onChange, type = "text", disabled = false, isTextarea = false }) {
    const { getLanguageAbbr } = useCookiesContext();
    const lang = getLanguageAbbr();
    const inputProps = {
        type,
        placeholder,
        value,
        onChange,
        disabled,
        ...(isTextarea && { as: 'textarea', rows: 3, style: { resize: 'none' } }),
      }

      const message = errorMessagesLabels[lang]?.valueIsTooLong || errorMessagesLabels.EN.valueIsTooLong
      const isInvalid = value?.length >= MAX_LENGTH

    return (
        <div className="setting-item">
            <Row className="g-2 align-items-center">
                <Col md="2">
                    <h6>{label}</h6>
                    {required && <p>{requiredLabels[lang] || 'Required'}</p>}
                </Col>
                <Col md>
                    <Form.Control {...inputProps} maxLength={MAX_LENGTH} isInvalid={isInvalid}  />
                    <Form.Control.Feedback type="invalid">
                        {message}
                    </Form.Control.Feedback>
                </Col>
            </Row>
        </div>
    )
}

export default memo(TextInput)
